/**
 * CSRF token fetcher with in-memory caching.
 *
 * The server sets the token in the session on the first GET /auth/csrf-token
 * call and expects it back as an X-CSRF-Token header on every mutating request.
 */

let cachedToken: string | null = null;

export async function getCsrfToken(): Promise<string> {
  if (cachedToken) return cachedToken;
  const res = await fetch("/api/auth/csrf-token", { credentials: "include" });
  if (!res.ok) throw new Error(`Failed to fetch CSRF token: ${res.status}`);
  const data = (await res.json()) as { csrf_token?: string };
  if (!data.csrf_token) throw new Error("CSRF token missing from response");
  cachedToken = data.csrf_token;
  return cachedToken;
}

/** Call after logout to force a fresh token on next mutation. */
export function invalidateCsrfToken(): void {
  cachedToken = null;
}
